module.exports = __webpack_public_path__ + "img/yishi27.101ea2d5.jpg";